export default "/images/fb3ab5a30de39e0c68592f60605c379e.avif";